<template>
  <page-header>
    <h2>Руководство пользователя</h2>
    <template #actions>
      <div class='d-flex align-items-baseline actions'>
        <button-component v-if="canEditManual" @click='editCard(null)'>Добавить</button-component>        
      </div>
    </template>    
  </page-header>

  <section class="content">
    <template v-if="items.length">
      <div class="table-inner">
        <table class="table-custom">
          <thead>
          <tr>
            <th style="width:50px"></th>
            <th>Наименование</th>
            <th>Описание</th>
            <th>Дата создания</th>
            <th>Тип файла</th>
            <th style="width:50px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id" @dblclick="editCard(item)">
            <td>
              <menu-component class="actions" :actions="actions(item)"/>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ $momentFormat(item.created, 'DD.MM.YYYY')}}</td>
            <td>{{ item.file.originalName.split('.').pop() }}, {{ (item.file.fileSize / 1024).toFixed(1) }} КБ</td>
            <td><a href="javascript:" class="btn" @click.prevent="downloadFile(item)"><i class="fa fa-download"></i></a></td>
          </tr>
          </tbody>
        </table>
      </div>      
    </template>
    <template v-else>
      <EmptyListMessage/>
    </template>  
  </section>
  <section class="modals">
      <modal-component v-if="modals.editManualItem" :title="currentItem.id ? 'Редактирование' : 'Создание'" size-class=""
                        @close="modals.editManualItem = false">
          <edit-manual :data="currentItem" v-on:save="save" @close="closeModal"/>
      </modal-component>
  </section>
</template>
<script>
import API from '../api/manual';
import PageHeader from "@/common/components/page/PageHeader";
import ButtonComponent from '@/common/ui/ButtonComponent';
import security from "@/common/mixins/security";
import Constants from '@/common/constants';
import ModalComponent from "@/common/ui/ModalComponent";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import EditManual from '../components/EditManual';
import FileAPI from "@/modules/file/api";

export default {
  name: "Manual",
  components: {
    PageHeader,    
    ButtonComponent,
    ModalComponent,
    MenuComponent,
    EditManual
  },
  mixins: [security],
  data() {
    return {
      items: [], 
      currentItem: {},  
      canEditManual: false,
      modals: {
        editManualItem: false
      }      
    }
  },
  created() {    
    this.checkPermission(Constants.ManualEdit).then(response => {
        this.canEditManual = response.data;
    }).finally(() => {
      this.loadPage();
    });    
  },
  methods: {
    actions(item) {
      let result = [];
      if (this.canEditManual) {
        result.push(
        {
          title: 'Редактировать',
          icon: 'pen',
          click: () => this.editCard(item)
        });
        result.push(  
        {
          title: 'Удалить',
          icon: 'trash',
          click: () => this.deleteCard(item.id)
        });
      }
      return result;
    },
    loadPage() {
      API.search().then((response) => {
        this.items = response.data;
      });
    },
    editCard(item) {
      if (!this.canEditManual)
        return;
      
      this.modals.editManualItem = false;

      if (item)
        this.currentItem = item;
      else
        this.currentItem = {};      

      this.modals.editManualItem = true;
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then((response) => {
            Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error')
            this.loadPage();
          })
        }
      })
    },
    save(item) {
      API.save(item).then(response => {
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error')
      }).finally(() => {
        this.closeModal();
        this.loadPage();
      });
    },
    closeModal() {
      this.modals.editManualItem = false;
      this.currentItem = {};
    },
    downloadFile(item) {
      FileAPI.download(item.fileId)
        .then(response => {
            const blob = new Blob([response.data], {type: item.file.contentType});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = item.file.originalName;
            link.click();
            URL.revokeObjectURL(link.href);
        });
    }
  }
}
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.content {
  padding: 32px;
  position: relative;
  overflow-y: visible;
}

.btn {
  display: inline-block;
}
.btn:focus{
    box-shadow: none !important;
    outline: none !important;
}

.fa-download{
    color: $blue-light
}
</style>